// extracted by mini-css-extract-plugin
export var activeFilterButton = "_rb-c";
export var backButton = "_rb-4";
export var backIcon = "_rb-5";
export var chevronShortcut = "_rb-6";
export var container = "_rb-1";
export var editor = "_rb-8";
export var editorWrapper = "_rb-7";
export var prefix = "_rb-2";
export var searchIcon = "_rb-3";
export var suffix = "_rb-9";
export var suffixContent = "_rb-a";
export var suffixText = "_rb-b";
export var wrapper = "_rb-0";